import axios from 'axios';
import DatricRequests from './datric.requests';
import { login, me } from './auth/auth.datric.api';
import { consultarCpf, consultaHistory, consultaHistoryDetail } from './consulta/consulta.datric.api';
import { getBalance, getStatement } from './credit/credit.datric.api';
import { createCardPayment, createPixPayment, getPayment, listPayments, quoteCardPayment } from './payment/payment.datric.api';
import { createBatchFile, createBatchJson, downloadBatch, getBatch, listBatches } from './batch/batch.datric.api';
import {
	addUserCredits,
	changeMyPassword,
	createUser,
	deleteUser,
	getUser,
	listUsers,
	setUserActive,
	setUserPassword,
	updateUser,
	updateUserLeilao,
	updateUserPrice
} from './user/user.datric.api';
import {
	createApiKey,
	deleteApiKey,
	listApiKeys,
	listAllApiKeys,
	listMyApiKeys,
	updateApiKeyPrice
} from './apiKey/apiKey.datric.api';
import { getApiKeyUsage, getByClient, getByIndicator, getOverview, getTimeline } from './dashboard/dashboard.datric.api';
import { getIntegrations, updateIntegration } from './integration/integration.datric.api';
import {
	exportLeilaoPurchases,
	getLeilaoConfig,
	listLeilaoLeads,
	listLeilaoPurchases,
	purchaseLeilaoLeads,
	updateLeilaoConfig
} from './leilao/leilao.datric.api';
import {
	createIndicator,
	deleteIndicator,
	listIndicators,
	setIndicatorActive,
	updateIndicator
} from './indicator/indicator.datric.api';

const token = localStorage.getItem('token');
if (token) {
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export const datricRequests = new DatricRequests();

export const datricApi = {
	logout,
	login,
	me,
	consulta: {
		consultar: consultarCpf,
		history: consultaHistory,
		historyDetail: consultaHistoryDetail
	},
	credit: {
		balance: getBalance,
		statement: getStatement
	},
	payment: {
		createPix: createPixPayment,
		quoteCard: quoteCardPayment,
		createCard: createCardPayment,
		list: listPayments,
		get: getPayment
	},
	batch: {
		createJson: createBatchJson,
		createFile: createBatchFile,
		list: listBatches,
		get: getBatch,
		download: downloadBatch
	},
	user: {
		list: listUsers,
		create: createUser,
		get: getUser,
		update: updateUser,
		updatePrice: updateUserPrice,
		updateLeilao: updateUserLeilao,
		setPassword: setUserPassword,
		changeMyPassword,
		addCredits: addUserCredits,
		setActive: setUserActive,
		delete: deleteUser
	},
	apiKey: {
		create: createApiKey,
		list: listApiKeys,
		listAll: listAllApiKeys,
		listMine: listMyApiKeys,
		updatePrice: updateApiKeyPrice,
		delete: deleteApiKey
	},
	dashboard: {
		overview: getOverview,
		byClient: getByClient,
		byIndicator: getByIndicator,
		timeline: getTimeline,
		apiKeyUsage: getApiKeyUsage
	},
	indicator: {
		list: listIndicators,
		create: createIndicator,
		update: updateIndicator,
		setActive: setIndicatorActive,
		delete: deleteIndicator
	},
	integration: {
		list: getIntegrations,
		update: updateIntegration
	},
	leilao: {
		leads: listLeilaoLeads,
		purchase: purchaseLeilaoLeads,
		purchases: listLeilaoPurchases,
		exportPurchases: exportLeilaoPurchases,
		getConfig: getLeilaoConfig,
		updateConfig: updateLeilaoConfig
	}
};

export function logout() {
	localStorage.clear();
	delete axios.defaults.headers.common['Authorization'];
	// @ts-ignore
	window.location = '/#/auth';
}
